import { Amount } from "./amount";
import { ChargebackStatus } from "./enum/chargeback-status";

export class VendorCentralStatusHistoryEntry {
  status: string = "";
  date: string = "";
}

export class Chargeback {
  id: string = "";
  payeeCode: string = "";
  accountName: string = "";
  chargebackId: string = "";
  financialCharge!: Amount;
  quantity: number = 0;
  issueType: string = "";
  creationDate?: string = undefined;
  disputeDateEnd?: string = undefined;
  invoiceNumber?: string = undefined;
  remittanceNumber?: string = undefined;
  reversalInvoiceNumber?: string = undefined;
  reversalRemittanceNumber?: string = undefined;
  notes?: string = undefined;
  vendorCentralStatus: string = "";
  vendorCentralStatusHistory?: VendorCentralStatusHistoryEntry[] = undefined;
  status: ChargebackStatus = ChargebackStatus.Pending;
  destination?: string = undefined;
  purchaseOrderNumber?: string = undefined;
  packageId?: string = undefined;
  trackingNumber?: string = undefined;
  asin?: string = undefined;
  ean?: string = undefined;
  disputeDates?: string[] = undefined;
  shipmentDeliveryWindowEnd?: string = undefined;
  shipmentDeliveryWindowStart?: string = undefined;
  deliveryDate?: string = undefined;
  reason?: string = undefined;
  summaryReason?: string = undefined;
  createdAt?: string = undefined;
  updatedAt?: string = undefined;
}

